'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Router = require('../../helpers/Router');

var _Login = require('../../helpers/Login');

var _Login2 = _interopRequireDefault(_Login);

var _BasePostLoginFlowStrategy = require('./BasePostLoginFlowStrategy');

var _BasePostLoginFlowStrategy2 = _interopRequireDefault(_BasePostLoginFlowStrategy);

var _ClientError = require('../../helpers/ClientError');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var B2CPostLoginFlowStrategy = function (_BasePostLoginFlowStr) {
  (0, _inherits3.default)(B2CPostLoginFlowStrategy, _BasePostLoginFlowStr);

  function B2CPostLoginFlowStrategy() {
    (0, _classCallCheck3.default)(this, B2CPostLoginFlowStrategy);
    return (0, _possibleConstructorReturn3.default)(this, (B2CPostLoginFlowStrategy.__proto__ || (0, _getPrototypeOf2.default)(B2CPostLoginFlowStrategy)).apply(this, arguments));
  }

  (0, _createClass3.default)(B2CPostLoginFlowStrategy, [{
    key: 'handleUserInfoResponse',
    value: function handleUserInfoResponse() {
      var auth = this.auth;
      var appInfo = this.appInfo;
      var log = this.log;
      var pushState = this.pushState;
      var userInfo = auth.userInfo;

      if (userInfo) {
        if (userInfo.loginFlags && userInfo.loginFlags.AGREEMENTS_APPROVAL_REQUIRED) {
          pushState((0, _Router.getPathWithWelcome)(_Router.RouterConst.ApproveAgreements));
        } else if (userInfo.loginFlags && userInfo.loginFlags.MAILING_LIST_SELECTION_REQUIRED) {
          pushState((0, _Router.getPathWithWelcome)(_Router.RouterConst.Communication));
        } else if (auth.tvCode) {
          pushState(_Router.RouterConst.TVLoginSuccess);
        } else {
          (0, _Login2.default)(auth.sessionId, auth, log, appInfo, pushState);
        }
      } else {
        (0, _ClientError.logClientErrorWithLoggingService)(auth.error || 'Error in B2CLoginStrategy', new Error().stack, 'universal-loginError', auth);
        pushState((0, _Router.getErrorRetryPath)());
      }
    }
  }]);
  return B2CPostLoginFlowStrategy;
}(_BasePostLoginFlowStrategy2.default);

exports.default = B2CPostLoginFlowStrategy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/login/strategy/B2CPostLoginFlowStrategy.js
// module id = 2033
// module chunks = 0